import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import messages from 'containers/LawyerLegalProceedingsPage/messages';
import { translate } from 'containers/services/translate';
import { FormContainer } from 'containers/PreOpeningPage/OpposingParty/styled-components';
import SahamAccordion from 'components/SahamAccordion';
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@material-ui/core';
import { ISuedPartyType } from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/typings';
import { isEmpty } from 'lodash';
import { Config } from 'containers/AppContainer/typings';

export interface SuedPartyRecapProps {
  intl: IntlShape;
  index: number;
  suedParty: ISuedPartyType;
  suedParties: ISuedPartyType[];
  setSuedParties: Function;
  setShowForm: Function;
  listingSuedParties: Config[];
}

const SuedPartyRecap: React.FC<SuedPartyRecapProps> = ({
  index,
  suedParty,
  suedParties,
  setSuedParties,
  setShowForm,
  listingSuedParties,
  ...props
}): JSX.Element => {
  const [expandedd, setExpandedd] = React.useState<boolean>(true);
  const handleClick = (event: React.ChangeEvent<{}>, expandedd: boolean) => {
    setExpandedd(expandedd);
  };

  const handleDelete = () => {
    const updatedSuedParties = suedParties.filter(
      (el: ISuedPartyType) =>
        !(
          el.condamnation === suedParty.condamnation &&
          el.suedPartyId === suedParty.suedPartyId
        ),
    );
    setSuedParties(updatedSuedParties);
    if (isEmpty(updatedSuedParties)) setShowForm(false);
  };

  return (
    <div className="sued-party-recap">
      <SahamAccordion
        title={translate(messages.suedParties, props, {
          number: index + 1,
        })}
        expanded={expandedd}
        onChange={handleClick}
        deleteButtonTitle={translate({ ...messages.delete }, props)}
        deleteButtonOnClick={handleDelete}
      >
        <>
          <FormContainer>
            <div className="condamnation-textfield">
              <TextField
                className="input-fields"
                label={translate({ ...messages.condamnationFieldTitle }, props)}
                defaultValue={suedParty.condamnation}
                InputProps={{ readOnly: true }}
              />
            </div>
            <FormControl>
              <InputLabel className="input-fields">
                {translate(messages.suedPartyTitle, props)}
              </InputLabel>
              <Select
                className="input-fields"
                value={suedParty.suedPartyId}
                disabled={true}
              >
                {!isEmpty(listingSuedParties) &&
                  listingSuedParties.map(suedParty => (
                    <MenuItem value={suedParty.id} key={suedParty.id}>
                      {suedParty.title}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </FormContainer>
        </>
      </SahamAccordion>
    </div>
  );
};

export default injectIntl(SuedPartyRecap);
